import { createTheme } from '@mui/material/styles';

// Colors based on the logo
const theme = createTheme({
    palette: {
        primary: {
            main: '#708090',
            light: '#d45e3a',
            dark: '#8c2e17',
            contrastText: '#fff',
        },
        secondary: {
            main: '#fff', // Orange from the sunburst
            light: '#ffa66b',
            dark: '#cc7035',
            contrastText: '#000',
        },
        background: {
            default: '#000',
            paper: '#A9A9A9',
        },
        text: {
            primary: '#fff',
            secondary: '#a5bed6',
        },
        success: {
            main: '#4caf50',
        },
        info: {
            main: '#4ba3c7', // Blue from the sky
        },
        warning: {
            main: '#ff9800',
        },
        error: {
            main: '#f44336',
        },
    },
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        h1: {
            fontWeight: 700,
        },
        h2: {
            fontWeight: 600,
        },
        h3: {
            fontWeight: 600,
        },
        h4: {
            fontWeight: 600,
        },
        h5: {
            fontWeight: 500,
        },
        h6: {
            fontWeight: 500,
        },
        button: {
            fontWeight: 500,
            textTransform: 'none',
        },
    },
    shape: {
        borderRadius: 8,
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    padding: '10px 24px',
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                    },
                },
                contained: {
                    '&:hover': {
                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                    },
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.05)',
                },
            },
        },
    },
});

export default theme;
